/** Shared stroke/fill tokens for overview Recharts (project analysis). */
export function overviewRechartsPalette(isDark: boolean) {
  return {
    grid: isDark ? '#475569' : '#e2e8f0',
    tick: isDark ? '#94a3b8' : '#64748b',
    tooltipBg: isDark ? '#1e293b' : '#fff',
    tooltipBorder: isDark ? '#334155' : '#e5e7eb',
  }
}
